import { SelectStation } from './SelectStation';
import { SceneProps, WizardOverlay } from '../common';
import { RentalDirection } from '../../SearchFormLegacy/context/types';

type Props = {
  direction: RentalDirection;
} & SceneProps;

const SelectStationScene = ({ direction, ...props }: Props) => (
  <WizardOverlay {...props} title={`Select ${direction} station`}>
    <SelectStation
      direction={direction}
      id={direction.slice(0, 3)}
      onServiceNumbersSubmit={() => {}}
      onSuggestionSelect={props.onConfirm}
    />
  </WizardOverlay>
);

export { SelectStationScene };
